import { BUILD_ENV } from '@/config/build-env';
import { resolveSupervisorAgentDialDigits } from '@/services/sip/counselorExtensions';
function digitsOnly(raw) {
    return raw.replace(/\D/g, '');
}
const DEFAULT_SNOOP_CODE = '901';
const DEFAULT_WHISPER_CODE = '902';
const DEFAULT_BARGE_CODE = '903';
const DEFAULT_CONFERENCE_CODE = '904';
const DEFAULT_FORCE_HANGUP_CODE = '905';
const DEFAULT_CONFERENCE_ROOM = '7001';
function dialPrefix(action) {
    switch (action) {
        case 'snoop':
            return BUILD_ENV.SIP_SUPERVISE_SNOOP_CODE || DEFAULT_SNOOP_CODE;
        case 'whisper':
            return BUILD_ENV.SIP_SUPERVISE_WHISPER_CODE || DEFAULT_WHISPER_CODE;
        case 'barge':
            return BUILD_ENV.SIP_SUPERVISE_BARGE_CODE || DEFAULT_BARGE_CODE;
        case 'conference':
            return BUILD_ENV.SIP_SUPERVISE_CONFERENCE_CODE || DEFAULT_CONFERENCE_CODE;
        case 'forceHangup':
            return BUILD_ENV.SIP_SUPERVISE_FORCE_HANGUP_CODE || DEFAULT_FORCE_HANGUP_CODE;
    }
}
/**
 * Returns a keypad string consumed by {@link sipDestinationUri} (`*` and `#` allowed).
 *
 * Format: `{actionCode}{destinationDigits}` — e.g. snoop agent 101 → `901101`.
 */
export function buildSupervisorDialString(action, parties) {
    const agent = resolveSupervisorAgentDialDigits(parties.agentExtension);
    const prefix = dialPrefix(action);
    if (action === 'conference') {
        const room = digitsOnly(BUILD_ENV.SIP_SUPERVISE_CONFERENCE_ROOM || DEFAULT_CONFERENCE_ROOM);
        if (!room) {
            throw new Error('Conference dial requires a numeric room (SIP_SUPERVISE_CONFERENCE_ROOM).');
        }
        return `${prefix}${room}`;
    }
    if (!agent) {
        throw new Error('Supervisor dial requires a numeric agent extension.');
    }
    return `${prefix}${agent}`;
}
export function supervisorActionLabel(action) {
    switch (action) {
        case 'snoop':
            return 'Snoop';
        case 'barge':
            return 'Barge';
        case 'whisper':
            return 'Whisper';
        case 'conference':
            return 'Conference';
        case 'forceHangup':
            return 'Force hangup';
        case 'disconnect':
            return 'Disconnect';
    }
}
